import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";
function AdminAddBlog() {

  const [blogs, setBlogs] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);
const [pendingComments, setPendingComments] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    category: "",
    description: "",
    image: "",
  });

  const [editForm, setEditForm] = useState({
    id: "",
    title: "",
    category: "",
    description: "",
    image: "",
  });

  // FETCH BLOGS
  const fetchBlogs = () => {

    fetch("https://swiftintelli.com/api/get_blogs.php")

      .then((res) => res.json())

      .then((data) => setBlogs(data))

      .catch((err) => {

  console.log(err);

  Swal.fire({
    icon: "error",
    title: "Load Failed",
    text: "Unable to fetch blogs",
  });

});
  };

  useEffect(() => {

  fetchBlogs();
  fetchPendingComments();

}, []);
  const fetchPendingComments = () => {

  fetch(
    "https://swiftintelli.com/api/get_pending_comments.php"
  )
    .then((res) => res.json())
    .then((data) => setPendingComments(data))
    .catch((err) => console.log(err));

};

  // HANDLE CHANGE
  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };

  // ADD BLOG
  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const response = await fetch(
        "https://swiftintelli.com/api/add_blog.php",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      Swal.fire({
  icon:
    data.status === "success"
      ? "success"
      : "error",

  title:
    data.status === "success"
      ? "Success"
      : "Failed",

  text: data.message,
});

      if (data.status === "success") {

        setFormData({
          title: "",
          category: "",
          description: "",
          image: "",
        });

        fetchBlogs();
      }

    } catch (error) {

      console.log(error);

      Swal.fire({
  icon: "error",
  title: "Server Error",
  text: "Something went wrong",
});
    }
  };

  // DELETE BLOG
  const deleteBlog = async (id) => {

  const result = await Swal.fire({
    title: "Delete Blog?",
    text: "This action cannot be undone",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Yes, Delete",
  });

  if (!result.isConfirmed)
    return;

  try {

    const res = await fetch(
      "https://swiftintelli.com/api/delete_blog.php",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({ id }),
      }
    );

    const data = await res.json();

    if (data.status === "success") {

      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: "Blog deleted successfully",
        timer: 1500,
        showConfirmButton: false,
      });

      fetchBlogs();

    } else {

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: "Unable to delete blog",
      });
    }

  } catch (error) {

    console.log(error);

    Swal.fire({
      icon: "error",
      title: "Server Error",
      text: "Something went wrong",
    });
  }
};

  // OPEN EDIT MODAL
  const openEditModal = (blog) => {

    setEditForm({
      id: blog.id,
      title: blog.title,
      category: blog.category,
      description: blog.description,
      image: blog.image,
    });

    setShowEditModal(true);
  };

  // HANDLE EDIT CHANGE
  const handleEditChange = (e) => {

    setEditForm({
      ...editForm,
      [e.target.name]: e.target.value,
    });

  };

  // UPDATE BLOG
  const updateBlog = async (e) => {

    e.preventDefault();

    try {

      const res = await fetch(
        "https://swiftintelli.com/api/edit_blog.php",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(editForm),
        }
      );

      const data = await res.json();

      if (data.status === "success") {

        Swal.fire({
  icon: "success",
  title: "Updated",
  text: "Blog updated successfully",
  timer: 1500,
  showConfirmButton: false,
});

        setShowEditModal(false);

        fetchBlogs();

      } else {

        Swal.fire({
  icon: "error",
  title: "Update Failed",
  text: "Unable to update blog",
});
      }

    } catch (err) {

      console.log(err);

      Swal.fire({
  icon: "error",
  title: "Server Error",
  text: "Something went wrong",
});
    }
  };

  const approveComment = async (id) => {

  try {

    const res = await fetch(
      "https://swiftintelli.com/api/approve_comment.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      }
    );

    const data = await res.json();

    if (data.status === "success") {

      Swal.fire({
        icon: "success",
        title: "Approved",
        text: "Comment approved successfully",
        timer: 1500,
        showConfirmButton: false,
      });

      fetchPendingComments();

    }

  } catch (err) {

    console.log(err);

  }

};
const rejectComment = async (id) => {

  try {

    const res = await fetch(
      "https://swiftintelli.com/api/reject_comment.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      }
    );

    const data = await res.json();

    if (data.status === "success") {

      Swal.fire({
        icon: "success",
        title: "Removed",
        text: "Comment rejected",
        timer: 1500,
        showConfirmButton: false,
      });

      fetchPendingComments();

    }

  } catch (err) {

    console.log(err);

  }

};

  return (
    <>
      <Navbar />

      <div className="admin-blog-page">

        <h1>Add Blog</h1>

        <form onSubmit={handleSubmit}>

          {/* TITLE */}

          <input
            type="text"
            name="title"
            placeholder="Blog Title"
            value={formData.title}
            onChange={handleChange}
            required
          />

          {/* CATEGORY */}

          <input
            type="text"
            name="category"
            placeholder="Category"
            value={formData.category}
            onChange={handleChange}
            required
          />

          {/* TEXT EDITOR */}

          <div className="ckeditor-wrapper">

            <CKEditor
              editor={ClassicEditor}
              disableWatchdog

              data={formData.description}

              onChange={(event, editor) => {

                const data = editor.getData();

                setFormData({
                  ...formData,
                  description: data,
                });

              }}

              config={{
                placeholder: "Write blog content here...",

                toolbar: [

                  "heading",

                  "|",

                  "bold",
                  "italic",

                  "|",

                  "bulletedList",
                  "numberedList",

                  "|",

                  "link",
                  "blockQuote",
                  "insertTable",

                  "|",

                  "undo",
                  "redo",

                ],
              }}
            />

          </div>

          {/* IMAGE */}

          <input
            type="text"
            name="image"
            placeholder="Image URL"
            value={formData.image}
            onChange={handleChange}
            required
          />

          <button type="submit">
            Add Blog
          </button>

        </form>

        <hr />

       

   <hr />

<div className="admin-blog-grid">

  {/* LEFT SIDE — BLOGS */}

  <div className="admin-blog-column">

    <h2>Blog List</h2>

    {blogs.map((blog) => (

      <div
        key={blog.id}
        className="blog-list-card"
      >

        <div className="blog-list-info">

          <h3>{blog.title}</h3>

          <p>{blog.category}</p>

        </div>

        <div className="blog-list-actions">

          <button
            className="btn-edit"
            onClick={() =>
              openEditModal(blog)
            }
          >
            Edit
          </button>

          <button
            className="btn-delete"
            onClick={() =>
              deleteBlog(blog.id)
            }
          >
            Delete
          </button>

        </div>

      </div>

    ))}

  </div>

  {/* RIGHT SIDE — PENDING COMMENTS */}

  <div className="admin-blog-column">

    <h2>Pending Comments</h2>

    {pendingComments.length === 0 && (
      <p>No pending comments</p>
    )}

    {pendingComments.map((comment) => (

      <div
        key={comment.id}
        className="blog-list-card"
      >

        <div className="blog-list-info">

          <h3>{comment.name}</h3>

          <p>
            <b>Blog:</b>
            {" "}
            {comment.blog_title}
          </p>

          <p>
            {comment.message}
          </p>

        </div>

        <div className="blog-list-actions">

          <button
            className="btn-edit"
            onClick={() =>
              approveComment(comment.id)
            }
          >
            Approve
          </button>

          <button
            className="btn-delete"
            onClick={() =>
              rejectComment(comment.id)
            }
          >
            Reject
          </button>

        </div>

      </div>

    ))}

  </div>

</div>



      </div>

      {/* EDIT MODAL */}

      {showEditModal && (

        <div className="edit-modal-overlay">

          <div className="edit-modal">

            <div className="edit-modal-header">

              <h2>Edit Blog</h2>

              <button
                className="close-btn"
                onClick={() =>
                  setShowEditModal(false)
                }
              >
                ✕
              </button>

            </div>

            <form onSubmit={updateBlog}>

              <input
                type="text"
                name="title"
                placeholder="Blog Title"
                value={editForm.title}
                onChange={handleEditChange}
                required
              />

              <input
                type="text"
                name="category"
                placeholder="Category"
                value={editForm.category}
                onChange={handleEditChange}
                required
              />

              <div className="ckeditor-wrapper">

  <CKEditor
    editor={ClassicEditor}

    disableWatchdog

    data={editForm.description}

    onChange={(event, editor) => {

      const data = editor.getData();

      setEditForm({
        ...editForm,
        description: data,
      });

    }}

    config={{
      placeholder: "Write blog content here...",

      toolbar: [

        "heading",

        "|",

        "bold",
        "italic",

        "|",

        "bulletedList",
        "numberedList",

        "|",

        "link",
        "blockQuote",
        "insertTable",

        "|",

        "undo",
        "redo",

      ],
    }}
  />

</div>

              <input
                type="text"
                name="image"
                placeholder="Image URL"
                value={editForm.image}
                onChange={handleEditChange}
                required
              />

              {editForm.image && (

                <img
                  src={editForm.image}
                  alt=""
                  className="edit-preview"
                />

              )}

              <div className="edit-actions">

                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() =>
                    setShowEditModal(false)
                  }
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="update-btn"
                >
                  Update Blog
                </button>

              </div>

            </form>

          </div>

        </div>

      )}

    </>
  );
}

export default AdminAddBlog;